<div class="container-fluid">
    <app-gene-table-selector [showGenomic] = true [showAssembly] = false [showRepseq]=false></app-gene-table-selector>
    <app-gen-sample-panel></app-gen-sample-panel>
</div>
